export const i18nConfig = {
  locales: ['en', 'pt-BR', 'fr-CA', 'de-DE'],
  defaultLocale: 'en'
}
